import { defineMessages } from 'react-intl'

export const getMessages = () =>
  defineMessages({
    stepWarning: {
      id:
        'To get the best choice of class times, we recommend selecting all the instructors found in the search results',
      defaultMessage:
        'To get the best choice of class times, we recommend selecting all the instructors found in the search results',
    },

    // Step 1 messages
    step1Label: {
      id: 'Tell us about your availability',
      defaultMessage: 'Tell us about your availability',
    },
    formDate: {
      id: 'I would like to start lessons on:',
      defaultMessage: 'I would like to start lessons on:',
    },
    formDatePlaceholder: {
      id: 'Select date',
      defaultMessage: 'Select date',
    },
    formDay: {
      id: 'I am available',
      defaultMessage: 'I am available',
    },
    formDayPlaceholder: {
      id: 'Select day',
      defaultMessage: 'Select day',
    },
    formTime: {
      id: 'at',
      defaultMessage: 'at',
    },
    formTimePlaceholder: {
      id: 'Select time',
      defaultMessage: 'Select time',
    },
    formSearchButton: {
      id: 'Find instructors',
      defaultMessage: 'Find instructors',
    },
    formModalButton: {
      id: 'Select day(s) and time(s)',
      defaultMessage: 'Select day(s) and time(s)',
    },
    formModalCancel: {
      id: 'Cancel',
      defaultMessage: 'Cancel',
    },

    // Step 2 messages
    step2Label: {
      id: 'Select instructors',
      defaultMessage: 'Select instructors',
    },
    selectAll: {
      id: 'Select all',
      defaultMessage: 'Select all',
    },
    sort: {
      id: 'Sort',
      defaultMessage: 'Sort',
    },
    mostAvailable: {
      id: 'Most available',
      defaultMessage: 'Most available',
    },
    leastAvailable: {
      id: 'Least available',
      defaultMessage: 'Least available',
    },

    // Step 3 messages
    step3Label: {
      id: 'View calendars',
      defaultMessage: 'View calendars',
    },
    step3LabelDesc: {
      id:
        'View the availability of selected instructors, including your favorite and past instructors, and choose the best times for you.',
      defaultMessage:
        'View the availability of selected instructors, including your favorite and past instructors, and choose the best times for you.',
    },

    // Profile modal message
    speaks: {
      id: 'Speaks',
      defaultMessage: 'Speaks',
    },
    alsoSpeaks: {
      id: 'Also speaks',
      defaultMessage: 'Also speaks',
    },
    teachingSince: {
      id: 'Teaching since',
      defaultMessage: 'Teaching since',
    },
    aboutMe: {
      id: 'About me',
      defaultMessage: 'About me',
    },

    // Error message
    errorHeader: {
      id: 'Oh no! Something went wrong',
      defaultMessage: 'Oh no! Something went wrong',
    },

    // Misc messages
    redirecting: {
      id: 'Redirecting...',
      defaultMessage: 'Redirecting...',
    },
  })
